import { render, staticRenderFns } from "./main.vue?vue&type=template&id=9bc71a96&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/scss/swal-custom.scss?vue&type=style&index=1&lang=scss&"
import style2 from "@/assets/scss/main.scss?vue&type=style&index=2&id=9bc71a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc71a96",
  null
  
)

export default component.exports